export const AUTH_TOKEN_COOKIE_NAME = "token";

function expireCookie(name, { domain, path = "/" } = {}) {
  // Use a fixed past date for broad browser compatibility.
  const expires = "Thu, 01 Jan 1970 00:00:00 GMT";
  let cookie = `${encodeURIComponent(name)}=; Expires=${expires}; Max-Age=0; Path=${path};`;
  if (domain) cookie += ` Domain=${domain};`;
  document.cookie = cookie;
}

/**
 * Ensures we never accidentally use the `.quizrr.in` scoped cookie.
 * If such a cookie exists, the browser will accept this deletion on hosts under quizrr.in.
 */
export function clearQuizrrParentDomainAuthCookie() {
  if (typeof document === "undefined") return;
  expireCookie(AUTH_TOKEN_COOKIE_NAME, { domain: ".quizrr.in", path: "/" });
  expireCookie(AUTH_TOKEN_COOKIE_NAME, { domain: "quizrr.in", path: "/" });
}
